import React from 'react';
import { Request } from '../../services/requestsService';
import { formatDateTime } from '../../utils/dateUtils';

interface CarInfoSectionProps {
  task: Request;
  carDetails: any;
  actionLoading: boolean;
}

const CarInfoSection: React.FC<CarInfoSectionProps> = ({
  task,
  carDetails,
  actionLoading
}) => {
  return (
    <div className="task-detail-section">
      <h2>Информация о машине</h2>
      <div className="task-detail-grid">
        <div className="task-detail-item">
          <span className="task-detail-label">Модель:</span>
          <span className="task-detail-value">{task.car?.name} {task.car?.model}</span>
        </div>
        <div className="task-detail-item">
          <span className="task-detail-label">Номер:</span>
          <span className="task-detail-value">{task.car?.number}</span>
        </div>
        {carDetails && (
          <>
            <div className="task-detail-item">
              <span className="task-detail-label">IMEI:</span>
              <span className="task-detail-value">{carDetails.imei}</span>
            </div>
            <div className="task-detail-item">
              <span className="task-detail-label">Аэропорт:</span>
              <span className="task-detail-value">{carDetails.airport}</span>
            </div>
            <div className="task-detail-item">
              <span className="task-detail-label">Дата создания:</span>
              <span className="task-detail-value">{formatDateTime(carDetails.createdAt)}</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CarInfoSection; 